import React from 'react';
import AuthErrorContainer from '../components/authError.container';

const AuthErrorPage: React.FC = () => <AuthErrorContainer />;

export default AuthErrorPage;
